document.addEventListener("DOMContentLoaded", () => {
    const params = new URLSearchParams(window.location.search);
    const utmParams = [
        "utm_source",
        "utm_medium",
        "utm_campaign",
        "utm_term",
        "utm_content",
    ];

    utmParams.forEach((key) => {
        if (params.has(key)) {
            sessionStorage.setItem(key, params.get(key));
        }
    });

    const utm = {};
    utmParams.forEach((key) => {
        const value = sessionStorage.getItem(key);
        if (value) utm[key] = value;
    });

    if (Object.keys(utm).length === 0) return;

    const currentHost = window.location.host;

    document.querySelectorAll("a").forEach((link) => {
        const href = link.getAttribute("href");
        if (
            href &&
            !href.includes("utm_") &&
            !href.startsWith("mailto:") &&
            !href.startsWith("tel:")
        ) {
            const url = new URL(href, window.location.origin);
            if (url.host === currentHost) {
                Object.entries(utm).forEach(([key, val]) =>
                    url.searchParams.set(key, val)
                );
                const newHref = href.startsWith('/')
                    ? url.pathname + url.search
                    : url.toString();
                link.setAttribute("href", newHref);
            }
        }
    });
});